import { useTranslation } from '../../../contexts/TranslationContext';
import { SettingsCard } from './SettingsCard';
import { DisclaimerText } from '../MHM/MHMTypography';
import { Stack } from '@mui/material';
import { MHMButton } from '../MHM/MHMButton';

export function ManualsSettingsComponent() {
  const { t } = useTranslation();

  return (
    <SettingsCard id="manuals" title={t('Manuals')} sx={{ overflow: 'unset' }}>
      <Stack gap={2} p={2}>
        <DisclaimerText>
          {t('Please use the link below to view the manuals')}
        </DisclaimerText>

        <MHMButton
          href="https://manual.manholemetrics.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ width: 'fit-content' }}
        >
          {t('View Manuals')}
        </MHMButton>
      </Stack>
    </SettingsCard>
  );
}
